import React, { useEffect, useState } from 'react';

const SCRIPT_URL_TARIFS = "https://script.google.com/macros/s/AKfycby-Cqdi-5vTC5zyH8NnMo2myE2ttny2bSJbZysS2-2yai775q2X4I_rkF8UW4JSFz5d/exec";

const ModuleReservation = () => {
  const [loading, setLoading] = useState(true);
  const [customTarifs, setCustomTarifs] = useState([]);

  useEffect(() => {
    // Chargement des tarifs avec timeout
    const timeoutId = setTimeout(() => {
      console.warn("Timeout chargement tarifs - Mode dégradé activé");
      setLoading(false);
    }, 5000);

    fetch(SCRIPT_URL_TARIFS + "?action=getTarifs")
      .then(r => r.json())
      .then(data => {
        clearTimeout(timeoutId);
        if (Array.isArray(data)) {
          setCustomTarifs(data);
        }
        setLoading(false);
      })
      .catch(e => {
        clearTimeout(timeoutId);
        console.error("Erreur chargement tarifs:", e);
        setLoading(false);
      });

    // Suppression de l'ancien script s'il existe
    const existingScript = document.getElementById('module-reservation-script');
    if (existingScript) {
      document.body.removeChild(existingScript);
      window.vtcResaInitialized = false;
    }

    // Injection du script de réservation
    const script = document.createElement('script');
    script.id = 'module-reservation-script';
    script.innerHTML = `
if (typeof window.vtcResaInitialized === 'undefined') {
  window.vtcResaInitialized = true;

var latBase = 50.6063;
var lonBase = 2.9348;
var latA=0, lonA=0, latB=0, lonB=0;
var latSup1=0, lonSup1=0, latSup2=0, lonSup2=0, latSup3=0, lonSup3=0; 
var latDepR=0, lonDepR=0, latArrR=0, lonArrR=0;
var searchTimeout;
var customTarifs = [];
var stopCount = 1;

// Fonction pour débloquer le bouton
function unlockButton() {
  const btn = document.getElementById('btn');
  if(btn) {
    btn.disabled = false;
    btn.innerText = "VALIDER LA COMMANDE";
  }
}

// Timeout de sécurité : débloquer après 5 secondes max
setTimeout(unlockButton, 5000);

// Chargement immédiat des tarifs avec timeout
const tarifTimeout = setTimeout(() => {
  console.warn("Timeout chargement tarifs - Mode dégradé activé");
  unlockButton();
}, 5000);

fetch("${SCRIPT_URL_TARIFS}?action=getTarifs")
  .then(r => r.json())
  .then(data => { 
    clearTimeout(tarifTimeout);
    if (Array.isArray(data)) { customTarifs = data; }
    unlockButton();
    calc();
  })
  .catch(e => {
    clearTimeout(tarifTimeout);
    console.error("Erreur chargement tarifs:", e);
    unlockButton();
  });

function isHolidayOrSunday(dateStr) {
  if (!dateStr) return false; let d = new Date(dateStr); if (d.getDay() === 0) return true; 
  let month = d.getMonth() + 1, day = d.getDate();
  if ((month===1&&day===1)||(month===5&&day===1)||(month===5&&day===8)||(month===7&&day===14)||(month===8&&day===15)||(month===11&&day===1)||(month===11&&day===11)||(month===12&&day===25)) return true;
  return false;
}

function toggleDates() {
  let type = document.querySelector('input[name="type_trajet"]:checked').value;
  let blocAller = document.getElementById('bloc_aller'), blocRetour = document.getElementById('bloc_retour');
  let lblAller = document.getElementById('lbl_date_aller');
  if (type === "Aller Simple") { blocAller.style.display = "flex"; blocRetour.style.display = "none"; lblAller.innerText = "Date Aller"; } 
  else if (type === "Retour Simple") { blocAller.style.display = "flex"; blocRetour.style.display = "none"; lblAller.innerText = "Date Prise"; } 
  else if (type === "Aller-Retour") { blocAller.style.display = "flex"; blocRetour.style.display = "block"; lblAller.innerText = "Date Aller"; }
  calc();
}

function addStop(btnElem) {
  if (stopCount === 1) { document.getElementById('bloc_sup_2').style.display = 'block'; stopCount++; }
  else if (stopCount === 2) { document.getElementById('bloc_sup_3').style.display = 'block'; stopCount++; btnElem.style.display = 'none'; }
}

function search(inp, boxId){
  let box=document.getElementById(boxId);
  if(!box || inp.value.length < 3){ 
    if(box) box.style.display="none"; 
    return; 
  }
  if(typeof searchTimeout !== 'undefined') clearTimeout(searchTimeout);
  searchTimeout = setTimeout(() => {
    fetch('https://nominatim.openstreetmap.org/search?format=json&limit=5&countrycodes=fr,be,nl&q=' + encodeURIComponent(inp.value))
    .then(r => r.json()).then(d => { 
      if(!box) return;
      box.innerHTML=""; 
      box.style.display="block"; 
      if(d && d.length > 0) {
        d.forEach(i => { 
          let dv=document.createElement('div'); 
          dv.innerText=i.display_name; 
          dv.onclick=() => { 
            inp.value=i.display_name; 
            if(boxId==='s_dep'){latA=parseFloat(i.lat);lonA=parseFloat(i.lon)}
            else if(boxId==='s_sup_1'){latSup1=parseFloat(i.lat);lonSup1=parseFloat(i.lon)}
            else if(boxId==='s_sup_2'){latSup2=parseFloat(i.lat);lonSup2=parseFloat(i.lon)}
            else if(boxId==='s_sup_3'){latSup3=parseFloat(i.lat);lonSup3=parseFloat(i.lon)}
            else if(boxId==='s_arr'){latB=parseFloat(i.lat);lonB=parseFloat(i.lon)} 
            else if(boxId==='s_dep_ret'){latDepR=parseFloat(i.lat);lonDepR=parseFloat(i.lon)}
            else if(boxId==='s_arr_ret'){latArrR=parseFloat(i.lat);lonArrR=parseFloat(i.lon)}
            box.style.display="none"; 
            calc(); 
          }; 
          box.appendChild(dv); 
        });
      } else {
        box.innerHTML = '<div style="padding: 8px; color: #94a3b8;">Aucune adresse trouvée</div>';
      }
    }).catch(e => { 
      console.error("Maps API error:", e);
      if(box) {
        box.innerHTML = '<div style="padding: 8px; color: #ef4444;">Erreur de recherche</div>';
      }
    });
  }, 600);
}

function getDist(la1,lo1,la2,lo2){ const R=6371; const dLat=(la2-la1)*Math.PI/180; const dLon=(lo2-lo1)*Math.PI/180; const a=Math.sin(dLat/2)**2+Math.cos(la1*Math.PI/180)*Math.cos(la2*Math.PI/180)*Math.sin(dLon/2)**2; return (2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a)))*R; }

function calc(){
  // Vérification de sécurité : les éléments existent-ils ?
  if (!document.getElementById('pax') || !document.getElementById('dep') || !document.getElementById('arr')) {
    return; // Sortir si les éléments n'existent pas (page différente)
  }
  
  let pax = parseInt(document.getElementById('pax').value);
  let txt = (document.getElementById('dep').value+" "+document.getElementById('arr').value).toLowerCase().normalize("NFD").replace(/[\\u0300-\\u036f]/g, "").replace(/-/g, " ");
  let type = document.querySelector('input[name="type_trajet"]:checked').value;
  let isAR = (type === "Aller-Retour");
  let pBase = 0;

  let chauf = (pax >= 4) ? "Patrick (Van)" : "Abdess (Berline)";

  const getForfait = (p2, p3, p4) => { 
      if(chauf.includes("Van") && pax < 4) return p4; 
      if(pax <= 2) return p2; 
      if(pax === 3) return p3; 
      if(txt.includes('mise a disposition') && pax >= 4) return p4; 
      if(pax === 4) return p4; 
      return p4 + ((pax-4)*5); 
  };

  let isForfait = false;

  if (Array.isArray(customTarifs)) {
      for (let i = 0; i < customTarifs.length; i++) {
          if (!customTarifs[i] || !customTarifs[i].motCle) continue;
          let motClePropre = customTarifs[i].motCle.toLowerCase().normalize("NFD").replace(/[\\u0300-\\u036f]/g, "").replace(/-/g, " ");
          if (txt.includes(motClePropre)) {
              pBase = getForfait(customTarifs[i].p2, customTarifs[i].p3, customTarifs[i].p4);
              isForfait = true; break;
          }
      }
  }

  if(!isForfait) {
      if(txt.includes('cdg') || txt.includes('roissy') || txt.includes('charles de gaulle')) { pBase=getForfait(290, 300, 310); isForfait = true; }
      else if(txt.includes('orly')) { pBase=getForfait(350, 360, 370); isForfait = true; }
      else if(txt.includes('charleroi')) { pBase=getForfait(190, 200, 210); isForfait = true; }
      else if(txt.includes('zaventem') || txt.includes('bruxelles')) { pBase=getForfait(190, 200, 210); isForfait = true; }
      else if(txt.includes('beauvais')) { pBase=getForfait(285, 295, 305); isForfait = true; }
      else if(txt.includes('eindhoven')) { pBase=getForfait(400, 410, 420); isForfait = true; }
      else if(txt.includes('amsterdam') || txt.includes('schiphol')) { pBase=getForfait(420, 430, 440); isForfait = true; }
      else if(txt.includes('ostende') || txt.includes('ostend')) { pBase=getForfait(150, 165, 175); isForfait = true; }
      
      else if(txt.includes('mise a disposition 1h')) { pBase=getForfait(80, 80, 80); isForfait = true; }
      else if(txt.includes('mise a disposition 2h')) { pBase=getForfait(160, 160, 160); isForfait = true; }
      else if(txt.includes('mise a disposition 3h')) { pBase=getForfait(240, 240, 240); isForfait = true; }
      else if(txt.includes('mise a disposition 4h')) { pBase=getForfait(320, 320, 320); isForfait = true; }
  }
  
  if(isForfait) {
     let distClient = 0;
     if (latA && latB) {
         let distA = getDist(latBase, lonBase, latA, lonA) * 1.3;
         let distB = getDist(latBase, lonBase, latB, lonB) * 1.3;
         distClient = Math.min(distA, distB);
     } else if (latA) {
         distClient = getDist(latBase, lonBase, latA, lonA) * 1.3;
     }
     if (distClient > 10) { pBase += (Math.ceil((distClient - 10) / 10) * 5); }
  }
  else if(latA && latB) {
      let kmTrajet = getDist(latA, lonA, latB, lonB) * 1.75;
      let kmApproche = getDist(latBase, lonBase, latA, lonA) * 1.75;
      let kmRetour = getDist(latB, lonB, latBase, lonBase) * 1.75;
      
      let pCalc = (kmTrajet * 1.40) + (kmApproche * 0.30) + (kmRetour * 0.30);
      if(kmTrajet > 100) pCalc = pCalc * 0.90;
      
      let prixBaseBerline = Math.max(pCalc, 50); 
      pBase = getForfait(prixBaseBerline, prixBaseBerline + 10, prixBaseBerline + 20);
  }

  let pExtra = 0;
  if (latA && lonA && latB && lonB) {
      let pathLat = [latA];
      let pathLon = [lonA];

      if (latSup1 && lonSup1 && document.getElementById('adr_sup_1').value !== "") { pathLat.push(latSup1); pathLon.push(lonSup1); }
      if (latSup2 && lonSup2 && document.getElementById('adr_sup_2').value !== "") { pathLat.push(latSup2); pathLon.push(lonSup2); }
      if (latSup3 && lonSup3 && document.getElementById('adr_sup_3').value !== "") { pathLat.push(latSup3); pathLon.push(lonSup3); }
      
      pathLat.push(latB);
      pathLon.push(lonB);

      if (pathLat.length > 2) { 
          let kmDirect = getDist(latA, lonA, latB, lonB) * 1.75;
          let kmAvecArrets = 0;
          for (let i = 0; i < pathLat.length - 1; i++) {
              kmAvecArrets += getDist(pathLat[i], pathLon[i], pathLat[i+1], pathLon[i+1]) * 1.75;
          }
          let kmDetour = kmAvecArrets - kmDirect;
          if (kmDetour > 0) { 
              pExtra = kmDetour * 1.40;
          }
      }
  }

  let prixFinal = 0;
  if (pBase > 0) {
      let pAller = pBase + pExtra;
      let dateAller = document.getElementById('date_aller').value;
      if (dateAller && isHolidayOrSunday(dateAller)) pAller *= 1.08;
      prixFinal += pAller;

      if (isAR) {
          let pBaseRetour = 0;
          let latDepRetourEffectif = latDepR ? latDepR : latB;
          let lonDepRetourEffectif = lonDepR ? lonDepR : lonB;
          let latArrRetourEffectif = latArrR ? latArrR : latA;
          let lonArrRetourEffectif = lonArrR ? lonArrR : lonA;

          if (!latDepR && !latArrR) {
              pBaseRetour = pBase;
          } else if (latDepRetourEffectif && latArrRetourEffectif) {
              let kmTrajetRetour = getDist(latDepRetourEffectif, lonDepRetourEffectif, latArrRetourEffectif, lonArrRetourEffectif) * 1.75;
              pBaseRetour = Math.max(kmTrajetRetour * 1.40, 50);
          }

          let pRetour = pBaseRetour + pExtra;
          let dateRetour = document.getElementById('date_retour').value;
          if (dateRetour && isHolidayOrSunday(dateRetour)) pRetour *= 1.08;
          prixFinal += pRetour;
      }
  }

  let payMethod = document.getElementById('pay').value;
  let fraisWeb = 0;
  if (payMethod === "ligne" && prixFinal > 0) {
      fraisWeb = Math.max(5, prixFinal * 0.05);
  }

  let total = Math.round(prixFinal + fraisWeb);
  
  document.getElementById('total').innerText= total > 0 ? total : "0";
  document.getElementById('ht').innerText=(total/1.1).toFixed(2);
  document.getElementById('tva').innerText=(total-(total/1.1)).toFixed(2);
  
  let msgFrais = document.getElementById('msg_frais');
  if (payMethod === "ligne" && prixFinal > 0) {
      msgFrais.style.display = "block";
  } else {
      msgFrais.style.display = "none";
  }
  
  let driverDisplay = document.getElementById('driver_display');
  if (driverDisplay) {
      driverDisplay.innerText = chauf;
  }
}

function send() {
  // Vérification de sécurité
  if (!document.getElementById('total') || !document.getElementById('nom') || !document.getElementById('email')) {
    return; // Sortir si les éléments n'existent pas
  }
  
  if(document.getElementById('total').innerText === "0") { alert("Veuillez remplir les adresses pour calculer le tarif."); return; }
  if(!document.getElementById('nom').value || !document.getElementById('email').value || !document.getElementById('tel').value) { alert("Nom, email et téléphone obligatoires"); return; }
  
  let btn = document.getElementById('btn');
  btn.disabled = true;
  btn.innerText = "ENVOI EN COURS...";

  let formData = new URLSearchParams();
  formData.append("civ", document.getElementById('civ').value);
  formData.append("nom", document.getElementById('nom').value);
  formData.append("email", document.getElementById('email').value);
  formData.append("tel", document.getElementById('tel').value);
  formData.append("adr_fiscale", document.getElementById('adr_fiscale').value);
  formData.append("pax", document.getElementById('pax').value);
  formData.append("dep", document.getElementById('dep').value);
  formData.append("arr", document.getElementById('arr').value);
  formData.append("date_aller", document.getElementById('date_aller').value);
  formData.append("heure_aller", document.getElementById('heure_aller').value);
  formData.append("prix", document.getElementById('total').innerText);
  formData.append("pay_method", document.getElementById('pay').value);
  formData.append("commentaires", document.getElementById('commentaires').value);
  
  let typeTrajet = document.querySelector('input[name="type_trajet"]:checked').value;
  formData.append("type_trajet", typeTrajet);
  
  if (typeTrajet === "Aller-Retour") {
      formData.append("date_retour", document.getElementById('date_retour').value);
      formData.append("heure_retour", document.getElementById('heure_retour').value);
      formData.append("dep_retour", document.getElementById('dep_retour').value || document.getElementById('arr').value);
      formData.append("arr_retour", document.getElementById('arr_retour').value || document.getElementById('dep').value);
  }

  let arretsSupp = [];
  if (document.getElementById('adr_sup_1').value) arretsSupp.push(document.getElementById('adr_sup_1').value);
  if (document.getElementById('adr_sup_2').value) arretsSupp.push(document.getElementById('adr_sup_2').value);
  if (document.getElementById('adr_sup_3').value) arretsSupp.push(document.getElementById('adr_sup_3').value);
  if (arretsSupp.length > 0) formData.append("arrets_supp", arretsSupp.join(" | "));

  fetch(SCRIPT_URL, {
      method: 'POST',
      body: formData
  })
  .then(response => response.text())
  .then(result => {
      if (document.getElementById('pay').value === "ligne" && result.startsWith("http")) {
          window.location.href = result;
      } else {
          alert("✅ Réservation confirmée ! Vous allez recevoir un email avec tous les détails.");
          btn.innerText = "COMMANDE VALIDÉE !";
      }
  })
  .catch(error => {
      alert("Erreur réseau. Veuillez réessayer.");
      btn.innerText = "VALIDER LA COMMANDE";
      btn.disabled = false;
  });
}

setInterval(calc, 1000);
} // Fin protection redéclaration
    `;
    document.body.appendChild(script);

    return () => {
      // Nettoyer le script au démontage
      const existingScript = document.getElementById('module-reservation-script');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
      window.vtcResaInitialized = false;
    };
  }, []);

  return (
    <div className="vtc-weppes-module" style={{ background: 'transparent', padding: '10px', width: '100%', fontFamily: "'Segoe UI', sans-serif", display: 'flex', justifyContent: 'center' }}>
      <style>{`
        .vtc-weppes-module * { box-sizing: border-box !important; }
        .vtc-weppes-module .resa-box { width: 100% !important; max-width: 550px !important; background-color: #0f172a !important; border: 2px solid #e2b13c !important; border-radius: 12px !important; padding: 20px !important; color: white !important; box-shadow: 0 10px 30px rgba(0,0,0,0.3) !important; text-align: left !important; }
        .vtc-weppes-module h2 { color: #e2b13c !important; text-align: center !important; border-bottom: 1px solid #e2b13c !important; padding-bottom: 10px !important; margin-top: 0 !important; font-size: 18px !important; text-transform: uppercase !important; line-height: 1.2 !important; }
        .vtc-weppes-module label { font-size: 11px !important; font-weight: bold !important; color: #e2b13c !important; display: block !important; margin-top: 12px !important; margin-bottom: 4px !important; text-transform: uppercase !important; letter-spacing: 0.5px !important; }
        .vtc-weppes-module input[type="text"], .vtc-weppes-module input[type="email"], .vtc-weppes-module input[type="date"], .vtc-weppes-module input[type="time"], .vtc-weppes-module select, .vtc-weppes-module textarea { width: 100% !important; padding: 10px !important; margin: 0 !important; border: 1px solid #334155 !important; background-color: #1e293b !important; color: white !important; border-radius: 5px !important; font-size: 13px !important; font-family: 'Segoe UI', sans-serif !important; height: auto !important; max-width: 100% !important; box-shadow: none !important; outline: none !important; }
        .vtc-weppes-module textarea { resize: vertical !important; min-height: 50px !important; }
        .vtc-weppes-module .row { display: flex !important; gap: 10px !important; width: 100% !important; }
        .vtc-weppes-module .row > div { flex: 1 !important; }
        .vtc-weppes-module .sugg { position: absolute !important; background: #1e293b !important; border: 1px solid #e2b13c !important; z-index: 9999 !important; width: 100% !important; max-height: 150px !important; overflow-y: auto !important; }
        .vtc-weppes-module .sugg div { padding: 8px !important; cursor: pointer !important; border-bottom: 1px solid #333 !important; font-size: 12px !important; color: white !important; }
        .vtc-weppes-module .sugg div:hover { background: #334155 !important; color: #e2b13c !important; }
        .vtc-weppes-module .price-box { background: rgba(226, 177, 60, 0.1) !important; border: 1px solid #e2b13c !important; padding: 15px !important; text-align: center !important; margin-top: 20px !important; border-radius: 8px !important; }
        .vtc-weppes-module .val-price { font-size: 32px !important; font-weight: 900 !important; color: #e2b13c !important; display: inline-block !important; }
        .vtc-weppes-module button.valider { width: 100% !important; background: #e2b13c !important; color: #0f172a !important; padding: 15px !important; border: none !important; border-radius: 5px !important; font-weight: bold !important; font-size: 16px !important; margin-top: 15px !important; cursor: pointer !important; text-transform: uppercase !important; }
        .vtc-weppes-module button.valider:disabled { background: #555 !important; color: #aaa !important; cursor: not-allowed !important; }
        .vtc-weppes-module button.add-stop { background: transparent !important; color: #e2b13c !important; border: 1px dashed #e2b13c !important; font-size: 11px !important; padding: 6px !important; margin-top: 5px !important; cursor: pointer !important; border-radius: 4px !important; width: auto !important; display: inline-block !important; text-align: center !important; }
        .vtc-weppes-module button.add-stop:hover { background: rgba(226, 177, 60, 0.1) !important; }
        .vtc-weppes-module .legal { font-size: 9px !important; text-align: center !important; color: #94a3b8 !important; margin-top: 10px !important; display: block !important; }
        .vtc-weppes-module .driver-tag { background: #e2b13c !important; color: #000 !important; padding: 4px 8px !important; border-radius: 4px !important; font-weight: bold !important; font-size: 11px !important; display: inline-block !important; margin-bottom: 5px !important; }
        .vtc-weppes-module .radio-group { display: flex !important; gap: 10px !important; margin-top: 5px !important; margin-bottom: 10px !important; background: #1e293b !important; padding: 10px !important; border-radius: 5px !important; border: 1px solid #334155 !important; }
        .vtc-weppes-module .radio-group label { display: flex !important; align-items: center !important; gap: 5px !important; margin-top: 0 !important; color: white !important; cursor: pointer !important; font-size: 11px !important; font-weight: normal !important; text-transform: none !important; }
        .vtc-weppes-module .radio-group input[type="radio"] { width: auto !important; margin: 0 !important; cursor: pointer !important; accent-color: #e2b13c !important; }
      `}</style>
      
      <div className="resa-box">
        <h2>RÉSERVATION VTC DES WEPPES</h2>
        
        <div className="row">
          <div style={{flex:1}}>
            <label>Civilité</label>
            <select id="civ">
              <option>Mr</option>
              <option>Mme</option>
              <option>Société</option>
            </select>
          </div>
          <div style={{flex:3}}>
            <label>Nom, Prénom ou Société</label>
            <input id="nom" type="text" placeholder="Obligatoire" />
          </div>
        </div>
        
        <label>Adresse Fiscale (Facture)</label>
        <input id="adr_fiscale" type="text" placeholder="Obligatoire pour la facturation" />
        
        <div className="row">
          <div style={{flex:1}}>
            <label>Tel</label>
            <input id="tel" type="text" placeholder="06... (Obligatoire)" />
          </div>
          <div style={{flex:1}}>
            <label>Email</label>
            <input id="email" type="email" placeholder="Obligatoire" />
          </div>
        </div>

        <div className="row">
          <div style={{flex:1}}>
            <label>Passagers</label>
            <select id="pax" onChange={() => window.calc && window.calc()}>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
            </select>
          </div>
          <div style={{flex:1}}>
            <label>Paiement</label>
            <select id="pay" onChange={() => window.calc && window.calc()}>
              <option value="bord">💶 Espèces/CB à bord</option>
              <option value="ligne">💻 Paiement en ligne sécurisé</option>
            </select>
          </div>
        </div>

        <label>Départ (Maps)</label>
        <div style={{position:'relative'}}>
          <input id="dep" type="text" onInput={(e) => window.search && window.search(e.target, 's_dep')} placeholder="Ex: 15 rue de Ligny ou Aéroport CDG" />
          <div id="s_dep" className="sugg"></div>
        </div>
        
        <label>Arrêt Supplémentaire 1 (Optionnel)</label>
        <div style={{position:'relative'}}>
          <input id="adr_sup_1" type="text" onInput={(e) => window.search && window.search(e.target, 's_sup_1')} placeholder="Ex: Arrêt en cours de route" />
          <div id="s_sup_1" className="sugg"></div>
        </div>
        
        <div id="bloc_sup_2" style={{display:'none', marginTop:'5px'}}>
          <label>Arrêt Supplémentaire 2</label>
          <div style={{position:'relative'}}>
            <input id="adr_sup_2" type="text" onInput={(e) => window.search && window.search(e.target, 's_sup_2')} placeholder="Ex: Deuxième arrêt" />
            <div id="s_sup_2" className="sugg"></div>
          </div>
        </div>

        <div id="bloc_sup_3" style={{display:'none', marginTop:'5px'}}>
          <label>Arrêt Supplémentaire 3</label>
          <div style={{position:'relative'}}>
            <input id="adr_sup_3" type="text" onInput={(e) => window.search && window.search(e.target, 's_sup_3')} placeholder="Ex: Troisième arrêt" />
            <div id="s_sup_3" className="sugg"></div>
          </div>
        </div>

        <button type="button" className="add-stop" onClick={(e) => window.addStop && window.addStop(e.target)}>+ Ajouter un autre arrêt</button>

        <label>Arrivée (Maps ou Forfait)</label>
        <div style={{position:'relative'}}>
          <input id="arr" type="text" onInput={(e) => window.search && window.search(e.target, 's_arr')} placeholder="Ex: Gare Lille Flandres ou 'mise a disposition 1h'" />
          <div id="s_arr" className="sugg"></div>
        </div>

        <label>Type de Trajet</label>
        <div className="radio-group">
          <label><input type="radio" name="type_trajet" value="Aller Simple" defaultChecked onChange={() => window.toggleDates && window.toggleDates()} /> Aller Simple</label>
          <label><input type="radio" name="type_trajet" value="Retour Simple" onChange={() => window.toggleDates && window.toggleDates()} /> Retour Simple</label>
          <label><input type="radio" name="type_trajet" value="Aller-Retour" onChange={() => window.toggleDates && window.toggleDates()} /> Aller-Retour</label>
        </div>

        <div id="bloc_aller" className="row">
          <div style={{flex:1}}>
            <label id="lbl_date_aller">Date</label>
            <input id="date_aller" type="date" onChange={() => window.calc && window.calc()} />
          </div>
          <div style={{flex:1}}>
            <label>Heure</label>
            <input id="heure_aller" type="time" onChange={() => window.calc && window.calc()} />
          </div>
        </div>
        
        <div id="bloc_retour" style={{display:'none', marginTop:'10px', background:'#1e293b', padding:'10px', borderRadius:'5px', border:'1px dashed #e2b13c'}}>
          <h4 style={{margin:'0 0 10px 0', color:'#e2b13c', fontSize:'12px', textTransform:'uppercase'}}>Options du Trajet Retour</h4>
          
          <label style={{color:'#94a3b8'}}>Départ Retour (Laissez vide si identique à l'arrivée aller)</label>
          <div style={{position:'relative'}}>
            <input id="dep_retour" type="text" onInput={(e) => window.search && window.search(e.target, 's_dep_ret')} placeholder="Ex: Autre adresse..." />
            <div id="s_dep_ret" className="sugg"></div>
          </div>
          
          <label style={{color:'#94a3b8'}}>Arrivée Retour (Laissez vide si identique au départ aller)</label>
          <div style={{position:'relative'}}>
            <input id="arr_retour" type="text" onInput={(e) => window.search && window.search(e.target, 's_arr_ret')} placeholder="Ex: Autre adresse..." />
            <div id="s_arr_ret" className="sugg"></div>
          </div>
          
          <div className="row" style={{marginTop:'10px'}}>
            <div style={{flex:1}}>
              <label id="lbl_date_retour">Date Retour</label>
              <input id="date_retour" type="date" onChange={() => window.calc && window.calc()} />
            </div>
            <div style={{flex:1}}>
              <label>Heure Retour</label>
              <input id="heure_retour" type="time" onChange={() => window.calc && window.calc()} />
            </div>
          </div>
        </div>

        <label>Informations Complémentaires (N° Vol, Train, Accès...)</label>
        <textarea id="commentaires" placeholder="Ex: Vol AF1234, Code portail..."></textarea>

        <div className="price-box">
          <div id="driver_display" className="driver-tag">Moteur blindé activé...</div>
          <br /><span style={{fontWeight:'bold', fontSize:'12px', color:'white'}}>TARIF TOTAL GARANTI</span><br />
          <span id="total" className="val-price">0</span> <span style={{fontSize:'24px', fontWeight:'bold', color:'#e2b13c'}}>€ TTC</span>
          <div id="msg_frais" style={{display:'none', fontSize:'10px', color:'#e2b13c', marginTop:'2px'}}>(Dont frais de service web sécurisé inclus)</div>
          <div style={{fontSize:'10px', marginTop:'5px', color:'#ccc'}}>HT : <span id="ht">0.00</span>€ | TVA 10% : <span id="tva">0.00</span>€</div>
        </div>

        <div style={{textAlign:'center', marginTop:'15px', marginBottom:'5px', background:'rgba(34, 197, 94, 0.1)', padding:'8px', borderRadius:'5px', border:'1px dashed #22c55e'}}>
          <div style={{color:'#22c55e', fontSize:'11px', fontWeight:'bold', letterSpacing:'0.5px'}}>
            🔒 PAIEMENT 100% SÉCURISÉ
          </div>
          <div style={{color:'#cbd5e1', fontSize:'10px', marginTop:'4px'}}>
            💳 CB • Visa • Mastercard • Amex <br />
            <span style={{fontSize:'9px', color:'#94a3b8'}}>Infrastructure bancaire propulsée par <strong>Stripe</strong></span>
          </div>
        </div>
        
        <button className="valider" onClick={() => window.send && window.send()} id="btn" disabled={loading}>
          {loading ? 'VEUILLEZ PATIENTER...' : 'VALIDER LA COMMANDE'}
        </button>
        <div className="legal">SAS VTC des Weppes - SIRET 918 489 659 00014</div>
      </div>
    </div>
  );
};

export default ModuleReservation;
